export const TIMEPERIOD_TIMESERIES_IO_DATA = {
	inputNodes: {
		MandatoryFields: [
			{
				groupId: 'PerformanceObject',
				colId: 'PerformanceObject',
				colText: 'Client',
				colHelp: 'Select the client for your report.',
				fieldType: 'Dropdown',
				defaultOption: null,
				selected: false,
				dropDowns: [],
			},
			{
				groupId: 'PerformanceIdentifier',
				colId: 'PerformanceIdentifier',
				colText: 'Account/Group',
				colHelp: 'Select the account[s] or group[s] for your report.',
				fieldType: 'Dropdown',
				defaultOption: null,
				selected: false,
				dropDowns: [],
			},
			{
				groupId: 'ReferenceDate',
				colId: 'ReferenceDate',
				colText: 'As Of Date',
				colHelp: 'Choose the reference date for your report.',
				fieldType: 'DatePicker',
				defaultOption: null,
				selected: false,
				dropDowns: [],
			},
		],
		NonMandatoryFields: [
			{
				groupId: 'Category',
				colId: 'Category',
				colText: 'Category',
				colHelp:
					'Select the calculated return category you wish to view.  ',
				fieldType: 'DropdownSmartSearch',
				defaultOption: 'Total Fund Gross of Fees',
				selected: false,
				dropDowns: [
					{
						listId: '1',
						listVal: 'Total Fund Gross of Fees',
						selected: 'Y',
					},
					{
						listId: '7173',
						listVal: 'Total Fund - Equity',
						selected: null,
					},
					{
						listId: '6677',
						listVal: 'Total Fund Net of Fees',
						selected: null,
					},
					{
						listId: '7008',
						listVal: 'Total Fund Net of Mgr. Fees',
						selected: null,
					},
					{
						listId: '8005',
						listVal: 'Total Fund - Sec. Lending',
						selected: null,
					},
					{
						listId: '7043',
						listVal: 'Total Fund - Foreign Exchange',
						selected: null,
					},
					{
						listId: '15027',
						listVal: 'Total Fund - Private Equity',
						selected: null,
					},
					{
						listId: '17324',
						listVal: 'TF Gross Derived from Fee Schedule',
						selected: null,
					},
					{
						listId: '17325',
						listVal: 'TF Net Derived from Fee Schedule',
						selected: null,
					},
					{
						listId: '17160',
						listVal: 'Total Fund- Gross of WH Tax Net of Fees',
						selected: null,
					},
					{
						listId: '18424',
						listVal: 'Total Fund: All Fees (accrued)',
						selected: null,
					},
					{
						listId: '18422',
						listVal: 'Total Fund: Mgmt Fees (accrued)',
						selected: null,
					},
					{
						listId: '18429',
						listVal:
							'Gross of Fees Gross of Withholding Tax Hedged',
						selected: null,
					},
					{
						listId: '18434',
						listVal:
							'Gross of Fees, Net of Withholding Tax, Unhedged',
						selected: null,
					},
					{
						listId: '19596',
						listVal: 'Gross of Fees Net of Withholding Tax Hedged',
						selected: null,
					},
					{
						listId: '19595',
						listVal: 'Net of Fees Gross of Withholding Tax Hedged',
						selected: null,
					},
					{
						listId: '18433',
						listVal: 'Net of Fees Net of Withholding Tax unhedged',
						selected: null,
					},
					{
						listId: '18435',
						listVal: 'Net of Fees Net of Withholding Tax Hedged',
						selected: null,
					},
					{
						listId: '19572',
						listVal: 'Net of Report Fees',
						selected: null,
					},
					{
						listId: '18423',
						listVal: 'Net of Report Perf. Fees',
						selected: null,
					},
					{
						listId: '19573',
						listVal: 'Net of Report Manager Fees',
						selected: null,
					},
					{
						listId: '8844',
						listVal: 'Total Fund Net of Taxes',
						selected: null,
					},
					{
						listId: '8845',
						listVal: 'Total Fund After-Tax',
						selected: null,
					},
					{
						listId: '8846',
						listVal: 'Total Net of Taxes & Fees',
						selected: null,
					},
					{
						listId: '6278',
						listVal: 'Equity',
						selected: null,
					},
					{
						listId: '6289',
						listVal: 'Common Stock',
						selected: null,
					},
					{
						listId: '6292',
						listVal: 'Common Stock Investments',
						selected: null,
					},
					{
						listId: '6291',
						listVal: 'Common Funds',
						selected: null,
					},
					{
						listId: '9145',
						listVal: 'Company Stock',
						selected: null,
					},
					{
						listId: '6287',
						listVal: 'Convertible Preferred Stock',
						selected: null,
					},
					{
						listId: '7060',
						listVal: 'Private Equity Funds',
						selected: null,
					},
					{
						listId: '6290',
						listVal: 'International Equity',
						selected: null,
					},
					{
						listId: '6823',
						listVal: 'Equity Derivatives',
						selected: null,
					},
					{
						listId: '6824',
						listVal: 'Equity Futures',
						selected: null,
					},
					{
						listId: '6825',
						listVal: 'Equity Options',
						selected: null,
					},
					{
						listId: '6826',
						listVal: 'Equity Swaps',
						selected: null,
					},
					{
						listId: '6288',
						listVal: 'Other Equity',
						selected: null,
					},
					{
						listId: '6692',
						listVal: 'Equity - Derivatives',
						selected: null,
					},
					{
						listId: '20698',
						listVal: 'Derivatives Overlay',
						selected: null,
					},
					{
						listId: '6277',
						listVal: 'Fixed Income',
						selected: null,
					},
					{
						listId: '13182',
						listVal: 'Fixed Income + Short Term Bonds',
						selected: null,
					},
					{
						listId: '6313',
						listVal: 'Marketable Bonds',
						selected: null,
					},
					{
						listId: '6317',
						listVal: 'Government Bonds',
						selected: null,
					},
					{
						listId: '6316',
						listVal: 'Government Related',
						selected: null,
					},
					{
						listId: '6318',
						listVal: 'Corporates',
						selected: null,
					},
					{
						listId: '6315',
						listVal: 'Mortgage Backed Bonds',
						selected: null,
					},
					{
						listId: '6314',
						listVal: 'Asset Backed Bonds',
						selected: null,
					},
					{
						listId: '8975',
						listVal: 'CMBS',
						selected: null,
					},
					{
						listId: '15165',
						listVal: 'Government/Government Related',
						selected: null,
					},
					{
						listId: '6312',
						listVal: 'Municipal/Provincial Bds',
						selected: null,
					},
					{
						listId: '6337',
						listVal: 'GICS and Synthetics',
						selected: null,
					},
					{
						listId: '6335',
						listVal: 'Collateralized Mortgage Oblig',
						selected: null,
					},
					{
						listId: '6714',
						listVal: 'International Fixed Income',
						selected: null,
					},
					{
						listId: '8546',
						listVal: 'Inflation Linked Bonds',
						selected: null,
					},
					{
						listId: '6719',
						listVal: 'Fixed Derivatives',
						selected: null,
					},
					{
						listId: '6720',
						listVal: 'Fixed Income Futures',
						selected: null,
					},
					{
						listId: '6722',
						listVal: 'Fixed Income Swaps',
						selected: null,
					},
					{
						listId: '6338',
						listVal: 'Other Fixed Income',
						selected: null,
					},
					{
						listId: '6690',
						listVal: 'Fixed Income - Derivatives',
						selected: null,
					},
					{
						listId: '9533',
						listVal: 'High Yield',
						selected: null,
					},
					{
						listId: '8521',
						listVal: 'Index Linked Gilts',
						selected: null,
					},
					{
						listId: '16237',
						listVal: 'Sukuk',
						selected: null,
					},
					{
						listId: '6275',
						listVal: 'Cash & Short Term Deriv.',
						selected: null,
					},
					{
						listId: '6355',
						listVal: 'Cash & Equivalents',
						selected: null,
					},
					{
						listId: '6354',
						listVal: 'Short Term Derivatives',
						selected: null,
					},
					{
						listId: '8006',
						listVal: 'Cash & Synthetic Cash',
						selected: null,
					},
					{
						listId: '6693',
						listVal: 'Fixed + Cash & Equivalents',
						selected: null,
					},
					{
						listId: '6726',
						listVal: 'Pending Cash',
						selected: null,
					},
					{
						listId: '6726',
						listVal: 'Futures Offsets',
						selected: null,
					},
					{
						listId: '6370',
						listVal: 'Equity Offsets',
						selected: null,
					},
					{
						listId: '6374',
						listVal: 'Fixed Income Offsets',
						selected: null,
					},
					{
						listId: '6276',
						listVal: 'Futures Offset',
						selected: null,
					},
					{
						listId: '6368',
						listVal: 'Short Term Offsets',
						selected: null,
					},
					{
						listId: '6371',
						listVal: 'Foreign Exchange Offsets',
						selected: null,
					},
					{
						listId: '6373',
						listVal: 'Commodity Offsets',
						selected: null,
					},
					{
						listId: '6372',
						listVal: 'Other Futures Offsets',
						selected: null,
					},
					{
						listId: '6279',
						listVal: 'Balanced Funds',
						selected: null,
					},
					{
						listId: '6272',
						listVal: 'Real Estate',
						selected: null,
					},
					{
						listId: '6281',
						listVal: 'Private Equity',
						selected: null,
					},
					{
						listId: '9653',
						listVal: 'Natural Resources',
						selected: null,
					},
					{
						listId: '7056',
						listVal: 'Hedge Funds',
						selected: null,
					},
					{
						listId: '7058',
						listVal: "LBO's",
						selected: null,
					},
					{
						listId: '6285',
						listVal: 'Commodities',
						selected: null,
					},
					{
						listId: '6380',
						listVal: 'Commodity Investments',
						selected: null,
					},
					{
						listId: '13305',
						listVal: 'Commodity Futures',
						selected: null,
					},
					{
						listId: '6379',
						listVal: 'Commodity Options',
						selected: null,
					},
					{
						listId: '13306',
						listVal: 'Commodity Swaps',
						selected: null,
					},
					{
						listId: '7054',
						listVal: 'Risk Arbitrage Funds',
						selected: null,
					},
					{
						listId: '9003',
						listVal: 'Mortgages',
						selected: null,
					},
					{
						listId: '9004',
						listVal: 'Loans',
						selected: null,
					},
					{
						listId: '7059',
						listVal: 'Distressed Security Funds',
						selected: null,
					},
					{
						listId: '9005',
						listVal: 'Doubtful & Desperate',
						selected: null,
					},
					{
						listId: '6286',
						listVal: 'Other Assets',
						selected: null,
					},
					{
						listId: '8705',
						listVal: 'Foreign Exchange Spot Trades',
						selected: null,
					},
					{
						listId: '8718',
						listVal: 'Gain/Loss on FX Hedges',
						selected: null,
					},
					{
						listId: '6282',
						listVal: 'Foreign Exchange',
						selected: null,
					},
					{
						listId: '6716',
						listVal: 'Foreign Exchange Swaps',
						selected: null,
					},
					{
						listId: '6715',
						listVal: 'Foreign Exchange Options',
						selected: null,
					},
					{
						listId: '6271',
						listVal: 'Securities Lending',
						selected: null,
					},
					{
						listId: '9403',
						listVal: 'Securitized',
						selected: null,
					},
					{
						listId: '15080',
						listVal: 'Imputed Tax Credits',
						selected: null,
					},
					{
						listId: '6274',
						listVal: 'Non Discretionary Assets',
						selected: null,
					},
					{
						listId: '6280',
						listVal: 'Family Assets',
						selected: null,
					},
					{
						listId: '6270',
						listVal: 'Excluded',
						selected: null,
					},
				],
			},
		],
	},
	outputNodes: {
		NonMandatoryFields: [
			{
				groupId: 'Optional',
				colId: 'acctGrpId',
				colText: 'Account / Group ID',
				colHelp: 'Account / Group ID',
				fieldType: null,
				defaultOption: null,
				selected: true,
				dropDowns: [],
			},
			{
				groupId: 'Optional',
				colId: 'AlternateID',
				colText: 'Alternate ID',
				colHelp: 'Alternate ID',
				fieldType: null,
				defaultOption: null,
				selected: false,
				dropDowns: [],
			},
			{
				groupId: 'Optional',
				colId: 'AccountGroup',
				colText: 'Account / Group Name',
				colHelp: 'Account / Group Name',
				fieldType: null,
				defaultOption: null,
				selected: true,
				dropDowns: [],
			},
			{
				groupId: 'Metrics',
				colId: 'beginningMarketValue',
				colText: 'Beginning Market Value',
				colHelp: 'Beginning Market Value',
				fieldType: null,
				defaultOption: null,
				selected: true,
				dropDowns: [],
			},
			{
				groupId: 'Metrics',
				colId: 'netContribution',
				colText: 'Net Contributions',
				colHelp: 'Net Contributions',
				fieldType: null,
				defaultOption: null,
				selected: false,
				dropDowns: [],
			},
			{
				groupId: 'Metrics',
				colId: 'mvContribution',
				colText: 'Contributions',
				colHelp: 'Contributions',
				fieldType: null,
				defaultOption: null,
				selected: true,
				dropDowns: [],
			},
			{
				groupId: 'Metrics',
				colId: 'withdrawals',
				colText: 'Withdrawals',
				colHelp: 'Withdrawals',
				fieldType: null,
				defaultOption: null,
				selected: true,
				dropDowns: [],
			},
			{
				groupId: 'Metrics',
				colId: 'Income',
				colText: 'Income',
				colHelp: 'Income',
				fieldType: null,
				defaultOption: null,
				selected: true,
				dropDowns: [],
			},
			{
				groupId: 'Metrics',
				colId: 'Fees',
				colText: 'Fees',
				colHelp: 'Fees',
				fieldType: null,
				defaultOption: null,
				selected: true,
				dropDowns: [],
			},
			{
				groupId: 'Metrics',
				colId: 'Appreciation',
				colText: 'Appreciation / Depreciation',
				colHelp: 'Appreciation / Depreciation',
				fieldType: null,
				defaultOption: null,
				selected: false,
				dropDowns: [],
			},
			{
				groupId: 'Metrics',
				colId: 'endingMarketValue',
				colText: 'Ending Market Value',
				colHelp: 'Ending Market Value',
				fieldType: null,
				defaultOption: null,
				selected: true,
				dropDowns: [],
			},
			{
				groupId: 'Optional',
				colId: 'timePeriod',
				colText: 'Time Period Analytics',
				colHelp: 'Time Period Analytics',
				fieldType: null,
				defaultOption: null,
				selected: true,
				dropDowns: [],
			},
		],
		arrangeFeildsOrder: [
			{
				id: 1,
				colId: 'acctGrpId',
				colText: 'Account / Group ID',
				colHelp: 'Account / Group ID',
				selected: true,
				mandatoryYN: null,
			},
			{
				id: 2,
				colId: 'AccountGroup',
				colText: 'Account / Group Name',
				colHelp: 'Account / Group Name',
				selected: true,
				mandatoryYN: null,
			},
			{
				id: 3,
				colId: 'ReferenceDateOut',
				colText: 'Reference Date',
				colHelp: 'Reference Date',
				selected: true,
				mandatoryYN: null,
			},
			{
				id: 4,
				colId: 'timePeriod',
				colText: 'Time Period Analytics',
				colHelp: 'Time Period Analytics',
				selected: true,
				mandatoryYN: null,
			},
			{
				id: 5,
				colId: 'beginningMarketValue',
				colText: 'Beginning Market Value',
				colHelp: 'Beginning Market Value',
				selected: true,
				mandatoryYN: null,
			},
			{
				id: 6,
				colId: 'mvContribution',
				colText: 'Contributions',
				colHelp: 'Contributions',
				selected: true,
				mandatoryYN: null,
			},
			{
				id: 7,
				colId: 'withdrawals',
				colText: 'Withdrawals',
				colHelp: 'Withdrawals',
				selected: true,
				mandatoryYN: null,
			},
			{
				id: 8,
				colId: 'Income',
				colText: 'Income',
				colHelp: 'Income',
				selected: true,
				mandatoryYN: null,
			},
			{
				id: 9,
				colId: 'Fees',
				colText: 'Fees',
				colHelp: 'Fees',
				selected: true,
				mandatoryYN: null,
			},
			{
				id: 10,
				colId: 'endingMarketValue',
				colText: 'Ending Market Value',
				colHelp: 'Ending Market Value',
				selected: true,
				mandatoryYN: null,
			},
		],
	},
	servicePath: 'https://phx-api-dev.ntrs.com/gateway-api-d/phx/v3/metrics',
};
